import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PROPERTIES } from "@/data";
import { PropertyCard } from "@/components/PropertyCard";
import { Reveal } from "@/components/Motion";

export default function Saved() {
  const { user, savedIds, loading } = useAuth();
  if (loading) return <div className="pt-40 pb-40 text-center text-charcoal/50">Loading…</div>;
  if (!user) return (
    <div className="pt-40 pb-40 text-center px-6">
      <Heart className="mx-auto text-gold mb-4" size={40} />
      <h1 className="font-serif text-3xl text-navy mb-3">Sign in to view saved homes</h1>
      <Link to="/login" data-testid="saved-signin" className="bg-gold text-navy font-semibold px-8 py-3 rounded-full inline-block">Sign In</Link>
    </div>
  );
  const saved = PROPERTIES.filter((p) => savedIds.includes(p.id));
  return (
    <div className="bg-cream pt-28 pb-24 px-6 md:px-12 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <Reveal><h1 className="font-serif text-5xl text-navy tracking-tighter mb-3">Saved homes</h1></Reveal>
        <Reveal delay={0.1}><p className="text-charcoal/60 mb-10">Welcome back, {user.first_name}. Here are the homes you've saved.</p></Reveal>
        {saved.length === 0 ? (
          <div className="bg-white rounded-2xl p-12 text-center border border-black/5" data-testid="saved-empty">
            <p className="text-charcoal/60 mb-4">You haven't saved any homes yet.</p>
            <Link to="/search" className="text-gold font-medium underline underline-offset-4">Browse homes →</Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{saved.map((p) => <PropertyCard key={p.id} p={p} />)}</div>
        )}
      </div>
    </div>
  );
}
